(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-features-list"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__featuresListToggleBound) return;
  window.__featuresListToggleBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.features-list__toggle');
    if (!btn) return;

    var root = btn.closest('.product-features-list');
    var list = root ? root.querySelector('.features-list__items') : btn.previousElementSibling;
    if (!list) return;

    var isExpanded = list.classList.toggle('expanded');
    btn.classList.toggle('expanded', isExpanded);

    var textEl = btn.querySelector('.features-list__toggle-text');
    if (textEl) {
      textEl.textContent = isExpanded
        ? (btn.getAttribute('data-hide-label') || 'Show Less')
        : (btn.getAttribute('data-show-label') || 'Show More');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
